module.exports = __webpack_public_path__ + "img/free_card.e318c9ee.png";